var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2V4H18.5859L16 6.58594L13.707 4.29297L12.293 5.70703L14.5859 8L13.3281 9.25781C12.2539 8.47266 10.9336 8 9.5 8C5.91406 8 3 10.9141 3 14.5C3 18.0859 5.91406 21 9.5 21C13.0859 21 16 18.0859 16 14.5C16 13.0664 15.5273 11.7461 14.7422 10.6719L16 9.41406L18.293 11.707L19.707 10.293L17.4141 8L20 5.41406V9H22V2H15ZM9.5 19C7.01953 19 5 16.9805 5 14.5C5 12.0195 7.01953 10 9.5 10C11.9805 10 14 12.0195 14 14.5C14 16.9805 11.9805 19 9.5 19Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderNeutral);
export default __webpack_public_path__ + "static/media/gender-neutral.e07282a09552471434aa8176726b3e76.svg";
export { ForwardRef as ReactComponent };